import React, { useState, useRef, memo, useEffect } from 'react';
import Explorer, { TreeControlDefaultState, TreeControlState } from 'components/explorer';
import TreeDataSupplier from 'business/tree/TreeDataSupplier';
import { removeItemIfFoundElsePush } from 'utils/Global';
import {
  useSearchDetailsOriginal,
  useSearchPaths,
  useSetSearchPaths,
} from 'redux/hooks/searchnFilter';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { ESearchPathFilters } from '../constants';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { getTreeNodePath } from '../utils';
import { TreeService } from 'business/services/TreeService';
import { filterAndTransformNode } from 'components/main/tree/utils';

interface Props {
  selectedPathFilter: ESearchPathFilters;
}

export const exludedNodesList = [
  ETreeNodeTypes.QuickAccess,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.RecycleBin,
];

const SearchPathSelector = (props: Props) => {
  const { selectedPathFilter } = props;
  const searchPaths = useSearchPaths();
  const setSearchPaths = useSetSearchPaths();
  const searchDetailsOriginal = useSearchDetailsOriginal();
  const searchParams = new URLSearchParams(window.location.search);
  const rawTreeNodeIds = searchParams.get('treeNodeIds');
  const queryTreeIds = rawTreeNodeIds
    ? rawTreeNodeIds
        .split(',')
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value))
    : [];
  const [treeControlState, setTreeControlState] = useState<TreeControlState>({
    ...TreeControlDefaultState,
    checkedExplorerNodes: queryTreeIds.length > 0 ? queryTreeIds : searchPaths,
  });
  const [selectedNodePaths, setSelectedNodePaths] = useState<{ [key: number]: string }>(
    {},
  );
  useEffect(() => {
    if (searchPaths.length > 0 && Object.keys(selectedNodePaths).length === 0) {
      new TreeService()
        .getTreeNodePaths(searchPaths)
        .then((paths) => setSelectedNodePaths(paths));
    }
  }, [searchPaths]);
  const handleOnSearchPathListChage = (nodeId: number) => {
    const tempState = [...treeControlState.checkedExplorerNodes];
    if (selectedNodePaths[nodeId]) {
      delete selectedNodePaths[nodeId];
    } else {
      const path = getTreeNodePath([...treeControlState.treenodes], nodeId);
      setSelectedNodePaths({ ...selectedNodePaths, [nodeId]: path.join('\\') });
    }
    removeItemIfFoundElsePush(tempState, nodeId);
    setTreeControlState({ ...treeControlState, checkedExplorerNodes: [...tempState] });
    setSearchPaths([...tempState]);
  };

  const explorerRef = useRef(null);

  const prevSearchDetailsRef = useRef<any>(null);

  useEffect(() => {
    if (
      queryTreeIds.length > 0 &&
      searchDetailsOriginal?.id > 0 &&
      !prevSearchDetailsRef.current
    ) {
      setSearchPaths(queryTreeIds);
    }
    prevSearchDetailsRef.current = searchDetailsOriginal;
  }, [searchDetailsOriginal]);

  return selectedPathFilter === ESearchPathFilters.All ? (
    <Explorer
      ref={explorerRef}
      backgroundColor="white"
      dataSupplier={TreeDataSupplier}
      setTreeControlState={setTreeControlState}
      treeControlState={treeControlState}
      shouldRenderNode={filterAndTransformNode}
      onCheckboxChange={handleOnSearchPathListChage}
      allowedRootTreeNodeTypes={[ETreeNodeTypes.Screens, ETreeNodeTypes.Projects]}
      shouldListenToBroadcastedEvents={false}
    />
  ) : (
    <div id="searchpathselector-path-item-wrapper">
      {Object.keys(selectedNodePaths).map((key) => (
        <SearchPathItem
          key={`search-path-item-${key}`}
          onRemove={() => handleOnSearchPathListChage(Number(key))}
          path={selectedNodePaths[key]}
        />
      ))}
    </div>
  );
};

export default memo(SearchPathSelector);

const SearchPathItem = ({ path, onRemove }: any) => {
  return (
    <div id={`searchpathitem-path-${path}-wrapper`} className="flex flex-row my-2">
      <span id={`searchpathitem-path-${path}-text`} className="basis-[90%]">
        {path}
      </span>
      <RMCustomButton
        iconProps={{ name: 'Delete', fill: '#DA1E28' }}
        onClick={onRemove}
      />
    </div>
  );
};
